(function () {
  'use strict';

  const cfg = window.__themeProductConfig || {};

  // ─────────────────────────────────────────────────────────────────
  // CRITICAL — define custom elements before user can interact.
  // slideshow-component, media-gallery MUST be registered immediately.
  // Both slideshow.js and media-gallery.js import from @theme/* aliases
  // so they MUST be loaded via importmap alias, not raw URL strings.
  // ─────────────────────────────────────────────────────────────────
  import('@theme/media-gallery');
  import('@theme/slideshow');        // ← defines <slideshow-component> — arrows + dots
  import('@theme/variant-picker');
  import('@theme/product-form');

  // media.js — needed for zoom / video on product images
  import('@theme/media');

  // ─────────────────────────────────────────────────────────────────
  // SECONDARY — safe to defer, does not affect slideshow interactivity
  // ─────────────────────────────────────────────────────────────────
  function loadSecondary() {
    if (cfg.productPrice)           import(cfg.productPrice);
    if (cfg.productInventory)       import(cfg.productInventory);
    if (cfg.productTitleTruncation) import(cfg.productTitleTruncation);
    if (cfg.videoBackground)        import(cfg.videoBackground);
    if (cfg.quantitySelector)       import(cfg.quantitySelector);
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(loadSecondary, { timeout: 3000 });
  } else {
    setTimeout(loadSecondary, 100);
  }

  // ─────────────────────────────────────────────────────────────────
  // RECENTLY VIEWED — fire and forget
  // ─────────────────────────────────────────────────────────────────
  if (cfg.recentlyViewed && cfg.productId) {
    import(cfg.recentlyViewed)
      .then(({ RecentlyViewed }) => {
        RecentlyViewed.addProduct(cfg.productId);
      })
      .catch(() => {});
  }

})();